export default __webpack_public_path__ + "static/media/cash.fe6046bc.png";